import { API_BASE_URL } from './constants';

export async function testNetworkConnectivity() {
  console.log('🔍 Testing network connectivity...');
  console.log('🔍 API Base URL:', API_BASE_URL);
  
  try {
    // Test basic connectivity with a simple request
    const response = await fetch(`${API_BASE_URL}/health`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    
    console.log('✅ Network test successful:', response.status, response.statusText);
    return { success: true, status: response.status };
  } catch (error) {
    console.error('❌ Network test failed:', error);
    const errorMessage = error instanceof Error ? error.message : 'Unknown error';
    return { success: false, error: errorMessage };
  }
}

export function getDeviceInfo() {
  console.log('📱 Device Info:');
  console.log('Platform:', typeof window !== 'undefined' ? 'web' : 'native');
  console.log('User Agent:', typeof navigator !== 'undefined' ? navigator.userAgent : 'N/A');
  
  if (typeof window !== 'undefined' && window.location) {
    console.log('Window location:', window.location.origin);
  }
}
